import communicate from 'src/api/communicate';
import toastrError from 'src/helpers/toastr/toastrError';
export var FreeTimeActions;
(function (FreeTimeActions) {
    FreeTimeActions["GET_FREE_TIME_REQUEST"] = "GET_FREE_TIME_REQUEST";
    FreeTimeActions["GET_FREE_TIME_SUCCESS"] = "GET_FREE_TIME_SUCCESS";
    FreeTimeActions["GET_FREE_TIME_FAIL"] = "GET_FREE_TIME_FAIL";
    FreeTimeActions["POST_FREE_TIME_REQUEST"] = "POST_FREE_TIME_REQUEST";
    FreeTimeActions["POST_FREE_TIME_SUCCESS"] = "POST_FREE_TIME_SUCCESS";
    FreeTimeActions["POST_FREE_TIME_FAIL"] = "POST_FREE_TIME_FAIL";
})(FreeTimeActions || (FreeTimeActions = {}));
export function getFreeTimeRequest() {
    return { type: FreeTimeActions.GET_FREE_TIME_REQUEST };
}
export function getFreeTimeSuccess(payload) {
    return { type: FreeTimeActions.GET_FREE_TIME_SUCCESS, payload };
}
export function getFreeTimeFail() {
    return { type: FreeTimeActions.GET_FREE_TIME_FAIL };
}
export function postFreeTimeRequest() {
    return { type: FreeTimeActions.POST_FREE_TIME_REQUEST };
}
export function postFreeTimeSuccess(payload) {
    return { type: FreeTimeActions.POST_FREE_TIME_REQUEST, payload };
}
export function postFreeTimeFail() {
    return { type: FreeTimeActions.POST_FREE_TIME_FAIL };
}
export function getFreeTime(payload) {
    return (dispatch) => {
        dispatch(getFreeTimeRequest());
        return communicate({
            url: 'v2/FreeTime/Search',
            method: 'POST',
            data: {
                PageSize: -1,
                PageNumber: 0,
                ...payload
            }
        })
            .then((response) => {
            dispatch(getFreeTimeSuccess(response.data));
        })
            .catch((e) => {
            dispatch(getFreeTimeFail());
            toastrError(e);
            return Promise.reject(e);
        });
    };
}
export function postFreeTime(payload) {
    return (dispatch) => {
        dispatch(postFreeTimeRequest());
        return communicate({
            url: 'v2/FreeTime/CreateUpdate',
            method: 'POST',
            data: payload
        })
            .then((response) => {
            dispatch(postFreeTimeSuccess(response.data.Data));
        })
            .catch((e) => {
            dispatch(postFreeTimeFail());
            toastrError(e);
            return Promise.reject(e);
        });
    };
}
